module.exports = __webpack_public_path__ + "static/img/icon_v_gift.83cfc6b8.png";